import { BASE_URL } from '../config';
const API_BASE_URL = BASE_URL;  // 使用统一的BASE_URL配置

// 主页静态数据
export const homeData = {
  id: '550e8400-e29b-41d4-a716-446655440000', // UUID格式
  title: '欢迎来到我们的网站',
  description: '这是一个示例描述，可以根据实际需求修改',
  image: 'https://example.com/default-image.jpg'
};

// 获取书单数据
export const getBookList = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/books`);
    if (!response.ok) {
      throw new Error('获取书单数据失败');
    }
    const data = await response.json();
    // 为每本书添加description字段
    return data.map(book => ({
      ...book,
      description: book.description || '暂无描述'
    }));
  } catch (error) {
    console.error('获取书单数据时出错:', error);
    return [];
  }
};


// 获取活动示例数据
export const getWorkshops = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/workshops`);
    if (!response.ok) {
      throw new Error('获取沙龙数据失败');
    }
    const data = await response.json();
    // 为每个活动添加description字段
    return data.map(event => ({
      ...event,
      description: event.description || '暂无活动描述'
    }));
  } catch (error) {
    console.error('获取沙龙数据时出错:', error);
    return [];
  }
};

// 导出动态获取的数据
export const bookList = await getBookList();
export const workshops = await getWorkshops();
